import React from 'react';
import { SunIcon, MoonIcon, MountainSnowIcon, SparklesIcon, ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
type Offering = {
  title: string;
  description: string;
  href: string;
  cta: string;
  Icon: typeof SunIcon;
};
const OFFERINGS: Offering[] = [{
  title: 'Group Classes',
  description: 'Flow in community. From gentle morning stretches to powerful vinyasa, find the class that meets you where you are.',
  href: 'https://fitculturepilates.com/locations/san-pedro-hot-room/#schedule',
  cta: 'See the class schedule',
  Icon: SunIcon
}, {
  title: 'Private Sessions',
  description: 'One-on-one guidance tailored to your body, your goals, and your journey. Deeply personal, deeply transformative.',
  href: 'mailto:jennawing@parnasociety.com?subject=Private%20session%20with%20PAR%E1%B9%86A',
  cta: 'Email Jenna',
  Icon: MoonIcon
}, {
  title: 'Retreats',
  description: 'Coming soon: immersive experiences in wild, breathtaking places. Until then, join us at a community gathering closer to home.',
  href: '#retreats',
  cta: 'Retreats coming soon',
  Icon: MountainSnowIcon
}, {
  title: 'Online Classes',
  description: 'Full classes on our YouTube channel, free and always there. Roll out your mat at sunrise or midnight and flow whenever you want to flow.',
  href: 'https://youtube.com/@parnasociety?si=WwYHN0g_EgY3Gb_C',
  cta: 'Watch on YouTube',
  Icon: SparklesIcon
}];
export function Offerings() {
  return <section id="offerings" className="w-full bg-shell py-24 md:py-32" data-id="element-79" data-mp="3e55sgipjus0f">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10" data-id="element-80" data-mp="3e78k176cot79">
        <Reveal data-id="element-81" data-mp="3a53qs9jtdyl5">
          <SectionLabel data-id="element-82" data-mp="3a4lwvjkmjwge">Offerings</SectionLabel>
        </Reveal>
        <Reveal delay={0.08} data-id="element-83" data-mp="3o4mzb3gjfbxz">
          <h2 className="mt-7 text-center font-display text-4xl font-light text-ink sm:text-5xl" data-id="element-84" data-mp="3o3v3brj13c76">
            Find your path
          </h2>
        </Reveal>

        <ul className="mx-auto mt-16 grid max-w-[1100px] gap-px overflow-hidden bg-clay/15 sm:grid-cols-2" data-id="element-85" data-mp="2grvoizc9mc3n">
          {OFFERINGS.map((offering, i) => {
          const isExternal = offering.href.startsWith('http');
          const isMail = offering.href.startsWith('mailto:');
          return <Reveal as="li" key={offering.title} delay={0.05 * i} className="bg-shell" data-id="element-86" data-mp="2uiqzch6br39v" data-mpi={i}>
                <a href={offering.href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className="group flex h-full flex-col p-9 transition-colors duration-500 hover:bg-cream md:p-11" data-id="element-87" data-mp="2zi3qhe48awi9">
                  <offering.Icon className="h-5 w-5 text-clay" strokeWidth={1.25} aria-hidden="true" data-id="element-88" data-mp="3dg21c9jccat0" />
                  <h3 className="mt-6 font-display text-2xl font-light text-ink" data-id="element-89" data-mp="1j2ix6gut1tyq">
                    {offering.title}
                  </h3>
                  <p className="mt-4 text-[14px] font-light leading-[1.85] text-muted" data-id="element-90" data-mp="1bl4b28l1lzgx">
                    {offering.description}
                  </p>
                  <span className="mt-7 flex items-center gap-2 text-[10px] font-light uppercase tracking-ultra text-clay" data-id="element-91" data-mp="11t89uonntt8h">
                    {offering.cta}
                    {(isExternal || isMail) && <ArrowUpRightIcon className="h-3.5 w-3.5 transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.25} aria-hidden="true" data-id="element-92" data-mp="1uhm917qhivlm" />}
                  </span>
                </a>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}